module.exports = __webpack_public_path__ + "25522407fb6c8c185b597f3c9fc59cde.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_1-320.webp
// module id = 281
// module chunks = 0